import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { WindowRefService } from './core/services/windowRef.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  constructor(private windowRefService: WindowRefService) {
    this.windowRefService.AJS.DesignTokens.setGlobalTheme({
      colorMode: 'auto',
    });

    setTimeout(() => {
      this.windowRefService.AP.getLocation((location: string) => {
        const colorMode = this.windowRefService.AJS.$('html').data('color-mode');
        if (colorMode && colorMode.toLowerCase() === 'dark') {
          if (location.toLocaleLowerCase().includes('selectedissue')) {
            this.windowRefService.AJS.$('body').css({ 'background-color': 'var(--ds-surface-overlay)' });
          }
        }
      });
    }, 50);
  }

  ngOnInit(): void {
    this.windowRefService.AP.resize('', '150');
  }
}
